import { Pipe, PipeTransform } from '@angular/core';
import { LocationRepository } from '@app/store/location.repository';
import { formatInTimeZone } from 'date-fns-tz';

@Pipe({
  name: 'propertyTz',
  standalone: true,
})
export class PropertyTimezonePipe implements PipeTransform {
  constructor(private locationRepo: LocationRepository) {}

  transform(date?: string | number | Date, format?: string): string {
    if (!date) {
      return '';
    }

    const location = this.locationRepo.getActiveLocation();
    const timezone = location?.timezone;

    if (!timezone) {
      return date.toString();
    }

    let dateObj: Date;
    if (typeof date === 'string' || typeof date === 'number') {
      dateObj = new Date(date);
    } else {
      dateObj = date;
    }

    // If no format is provided, return the default JS date string in the correct timezone
    if (!format) {
      return dateObj.toLocaleString('en-US', { timeZone: timezone });
    }

    return formatInTimeZone(dateObj, timezone, format);
  }
}
